import { Flex } from "@chakra-ui/layout";
import styled from "styled-components";

import { Tabbar } from "../Tabbar"
import FilterComponent from "../FilterComponent";
import { Container, Wrapper, FlexStyled } from "./styles";
import { useFilters } from "core/features/filters/store";
import GestaoJustificativa from "../GestaoJustificativa";
import AgendaCampo from "../AgendaCampo";
import Relatorios from "../Relatorios";

const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;

interface AppbarProps {
  filters: any;
  setFilters: any;
  planoOperacionalData: any;
  dataMapOS?: any;
  refetch: any;
  refetchMap: any;
}

function Appbar({
  filters,
  setFilters,
  planoOperacionalData,
  dataMapOS,
  refetch,
  refetchMap
}: AppbarProps) {
  const { filters: { menuName, tabBarSessaoPlanejamentoOperacional, menuNameRelatorios } } = useFilters();
  return (
    <Container>
      <Wrapper>
        <FlexStyled>
          <FilterComponent
            filters={filters}
            setFilters={setFilters}
            planoOperacionalData={planoOperacionalData}
            dataMapOS={dataMapOS}
            refetch={refetch}
            refetchMap={refetchMap}
          />
        </FlexStyled>
        <Content>
          <Tabbar />
        </Content>
      </Wrapper>
          {tabBarSessaoPlanejamentoOperacional === 'execucao-operacional' && menuName === 'Gestão de Justificativa' && (
            <Flex flex={1}>
              <GestaoJustificativa
                filtrosAvancados={planoOperacionalData?.filtrosAvancados}
              />
            </Flex>
            )
          }
          {tabBarSessaoPlanejamentoOperacional === 'agenda-campo' && (
            <Flex flex={1}>
              <AgendaCampo
                filtrosAvancados={planoOperacionalData?.filtrosAvancados}
              />
            </Flex>
            )
          }
          {tabBarSessaoPlanejamentoOperacional === 'relatorios' && menuNameRelatorios !== "Relatório de Aderência Operacional" && (
            <Flex flex={1}>
              <Relatorios
                filtrosAvancados={planoOperacionalData?.filtrosAvancados}
              />
            </Flex>
            )
          }
    </Container>
  );
}

export default Appbar;
